import "./Funcionalidad.css";

export const Funcionalidad = (props) => {
  const { funcionalidad } = props;
  const imageKey = Object.keys(funcionalidad.image)[0]; // Obtener la clave de la imagen
  const imageSrc = funcionalidad.image[imageKey]; // Obtener la ruta de la imagen

  return (
    <div className="funcionalidad-box">
      <div className="funcionalidad-image">
        <img src={imageSrc} alt="" />
      </div>
      <div className="funcionalidad-text">{funcionalidad.title}</div>
    </div>
  );
};

export default Funcionalidad;
